export const DEVICE_WIDTH = 40;
export const DEVICE = 'DEVICE';
export const DEVICE_ID = 'DEVICE_ID';
export const PERSON_ID = 'PERSON_ID';
export const PERSON_WIDTH = 80;
export const PERSON = 'PERSON';
export const ZONE_ID = 'ZONE_ID';
export const IMAGE_COLLECTION = 'IMAGE_COLLECTION';
export const DEVICE_COLLECTION = 'DEVICE_COLLECTION';
export const PERSON_COLLECTION = 'PERSON_COLLECTION';
export const ROI_COLLECTION = 'ROI_COLLECTION';
export const HOTAREA_COLLECTION = 'HOTAREA_COLLECTION';
export const HEATMAP_COLLECTION = 'HEATMAP_COLLECTION';
export var MapSate;
(function (MapSate) {
    MapSate["OnLocation"] = "OnLocation";
})(MapSate || (MapSate = {}));
